// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer utilities {
  .max-w-4xs {
    max-width: 8rem;
  }
  .max-w-3xs {
    max-width: 12rem;
  }
  .max-w-2xs {
    max-width: 16rem;
  }

  .min-w-0 {
    min-width: 0rem;
  }
  .min-w-none {
    min-width: none;
  }
  .min-w-4xs {
    min-width: 8rem;
  }
  .min-w-3xs {
    min-width: 12rem;
  }
  .min-w-2xs {
    min-width: 16rem;
  }
  .min-w-xs {
    min-width: 20rem;
  }
  .min-w-sm {
    min-width: 24rem;
  }
  .min-w-md {
    min-width: 28rem;
  }
  .min-w-lg {
    min-width: 32rem;
  }
  .min-w-xl {
    min-width: 36rem;
  }
  .min-w-2xl {
    min-width: 42rem;
  }
  .min-w-3xl {
    min-width: 48rem;
  }
  .min-w-4xl {
    min-width: 56rem;
  }
  .min-w-5xl {
    min-width: 64rem;
  }
  .min-w-6xl {
    min-width: 72rem;
  }
  .min-w-7xl {
    min-width: 80rem;
  }
  .min-w-full {
    min-width: 100%;
  }
  .min-w-min {
    min-width: -moz-min-content;
    min-width: min-content;
  }
  .min-w-min {
    min-width: -moz-min-content;
    min-width: min-content;
  }
  .min-w-prose {
    min-width: 65ch;
  }
  .min-w-screen-sm {
    min-width: 640px;
  }
  .min-w-screen-md {
    min-width: 768px;
  }
  .min-w-screen-lg {
    min-width: 1024px;
  }
  .min-w-screen-xl {
    min-width: 1280px;
  }
  .min-w-screen-2xl {
    min-width: 1536px;
  }
}

#myCoolBackground {
  background-color: #939393;
  /* --s: 100px; */
  /* control the size */

  /* --_g: #0000 90deg, #1f2937 0;
    background:
      conic-gradient(from 116.56deg at calc(100%/3) 0, var(--_g)),
      conic-gradient(from -63.44deg at calc(200%/3) 100%, var(--_g)) #22d3ee;
    background-size: var(--s) var(--s); */
}

#mainBackground {
  background-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAAsB;IAAtB,sBAAsB;EACxB;EACA;IACE,2BAAsB;IAAtB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;;EAErB;;;;yCAIuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@layer utilities {\n  .max-w-4xs {\n    max-width: 8rem;\n  }\n  .max-w-3xs {\n    max-width: 12rem;\n  }\n  .max-w-2xs {\n    max-width: 16rem;\n  }\n\n  .min-w-0 {\n    min-width: 0rem;\n  }\n  .min-w-none {\n    min-width: none;\n  }\n  .min-w-4xs {\n    min-width: 8rem;\n  }\n  .min-w-3xs {\n    min-width: 12rem;\n  }\n  .min-w-2xs {\n    min-width: 16rem;\n  }\n  .min-w-xs {\n    min-width: 20rem;\n  }\n  .min-w-sm {\n    min-width: 24rem;\n  }\n  .min-w-md {\n    min-width: 28rem;\n  }\n  .min-w-lg {\n    min-width: 32rem;\n  }\n  .min-w-xl {\n    min-width: 36rem;\n  }\n  .min-w-2xl {\n    min-width: 42rem;\n  }\n  .min-w-3xl {\n    min-width: 48rem;\n  }\n  .min-w-4xl {\n    min-width: 56rem;\n  }\n  .min-w-5xl {\n    min-width: 64rem;\n  }\n  .min-w-6xl {\n    min-width: 72rem;\n  }\n  .min-w-7xl {\n    min-width: 80rem;\n  }\n  .min-w-full {\n    min-width: 100%;\n  }\n  .min-w-min {\n    min-width: min-content;\n  }\n  .min-w-min {\n    min-width: min-content;\n  }\n  .min-w-prose {\n    min-width: 65ch;\n  }\n  .min-w-screen-sm {\n    min-width: 640px;\n  }\n  .min-w-screen-md {\n    min-width: 768px;\n  }\n  .min-w-screen-lg {\n    min-width: 1024px;\n  }\n  .min-w-screen-xl {\n    min-width: 1280px;\n  }\n  .min-w-screen-2xl {\n    min-width: 1536px;\n  }\n}\n\n#myCoolBackground {\n  background-color: #939393;\n  /* --s: 100px; */\n  /* control the size */\n\n  /* --_g: #0000 90deg, #1f2937 0;\n    background:\n      conic-gradient(from 116.56deg at calc(100%/3) 0, var(--_g)),\n      conic-gradient(from -63.44deg at calc(200%/3) 100%, var(--_g)) #22d3ee;\n    background-size: var(--s) var(--s); */\n}\n\n#mainBackground {\n  background-color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
